import React, {Suspense, useState, useEffect} from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PakitoList from '../../pages/pakito/PakitoList';
import PakitoShow from '../../pages/pakito/PakitoShow';

function PakitoDashboard(props) {
  const { url, path } = useRouteMatch();
  const { t, i18n } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={PakitoList}/>
        <Route path={`${path}/:id`} component={PakitoShow}/>
      </Switch>
    </Suspense>
	)
}

export default PakitoDashboard
